<xemex-card
  [title]="'devices.detailTabs.insights.performance.title' | translate"
  [loading]="loading()"
>
  <xemex-tag
    cardHeaderActions
    [state]="verdict().state"
    [label]="verdict().labelKey | translate"
  ></xemex-tag>

  @if (hasData()) {
    <div class="performance">
      <p class="performance__subtitle">
        {{ 'devices.detailTabs.insights.performance.subtitle' | translate }}
      </p>

      <div class="performance__stats">
        <div class="performance__hero">
          <span class="performance__label">
            {{ 'devices.detailTabs.insights.performance.lastSevenDays' | translate }}
          </span>
          <span
            class="performance__hero-value"
            [class]="'performance__hero-value--' + sevenDayTone()"
          >
            {{ sevenDayLabel() }}
          </span>
        </div>

        <div class="performance__secondary">
          <div>
            <span class="performance__label">
              {{
                'devices.detailTabs.insights.performance.lastDayOn'
                  | translate: { date: anchorDayLabel() }
              }}
            </span>
            <span class="performance__value">{{ lastDayLabel() }}</span>
          </div>
          <div>
            <span class="performance__label">
              {{ 'devices.detailTabs.insights.performance.lastThirtyDays' | translate }}
            </span>
            <span class="performance__value">{{ thirtyDayLabel() }}</span>
          </div>
        </div>
      </div>

      @if (hasTrend()) {
        <div class="performance__trend">
          <xemex-chart
            chartType="line"
            heightClass="h-48"
            [datasets]="trendDatasets()"
            [labels]="trendLabels()"
            [options]="chartOptions()"
            [syncHover]="false"
          ></xemex-chart>
          <p class="performance__caption">
            {{ 'devices.detailTabs.insights.performance.trendCaption' | translate }}
          </p>
        </div>
      } @else {
        <p class="performance__trend-note">
          {{ 'devices.detailTabs.insights.performance.empty.trendNote' | translate }}
        </p>
      }
    </div>
  } @else {
    <div class="performance-empty">
      <mat-icon class="performance-empty__icon" aria-hidden="true">query_stats</mat-icon>
      <p class="performance-empty__title">
        {{ 'devices.detailTabs.insights.performance.empty.title' | translate }}
      </p>
      <p class="performance-empty__body">
        {{ 'devices.detailTabs.insights.performance.empty.body' | translate }}
      </p>
    </div>
  }
</xemex-card>
